import { computed, type ComputedRef } from 'vue';
import useKillSwitches from '@/composables/useKillSwitches';
import { usePageDataStore } from '@/stores/pageDataStore';
import checkingRouteForSysPage from '~/features/shop-your-store/composables/checkRouteForSysPage';

export default function useGetItToday(): { isGetItTodayEnabled: ComputedRef<boolean> } {
  const { getItTodayEnabled } = useKillSwitches();
  const isSYS = !!checkingRouteForSysPage();
  const pageDataStore = usePageDataStore();
  const isEnabledOnPageLevel = computed(() => !pageDataStore.getDisableDeliveryAndFulfillmentFacet && pageDataStore.getIsDomestic);

  const isGetItTodayEnabled = computed(() => {
    return getItTodayEnabled && isEnabledOnPageLevel.value && !isSYS;
  });

  return {
    isGetItTodayEnabled,
  };
}
